export type ValidationResponse<TParams = { [id: string]: unknown }> = {
  details: string;
  status: 'OK' | 'VALIDATION_ERROR' | 'WARNING';
  params?: TParams;
};

export enum ValidationStatuses {
  OK = 'OK',
  VALIDATION_ERROR = 'VALIDATION_ERROR',
  WARNING = 'WARNING',
}
